import { Component, OnInit } from '@angular/core';
import Map from 'ol/Map';
import OSM from 'ol/source/OSM';
import View from 'ol/View';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { fromLonLat } from 'ol/proj.js';
import { transform } from 'ol/proj.js';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import { Icon, Style, Stroke } from 'ol/style';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { VehiclePosition } from 'src/app/_models/vehiclePosition';
import { MapService } from 'src/app/_services/map.service';
import { LineString } from 'ol/geom';

@Component({
  selector: 'app-mapRoutes',
  templateUrl: './mapRoutes.component.html',
  styleUrls: ['./mapRoutes.component.css']
})
export class MapRoutesComponent implements OnInit {

  map;
  vectorSource;
  vectorLayer;
  // position: VehiclePosition;
  positions: VehiclePosition[];
  constructor(private route: ActivatedRoute, private mapService: MapService, private http: HttpClient) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.positions = data['positions'];
      this.initilizeMap();
    });
    // this.mapService.getLastPosition(this.route.snapshot.params['id']).subscribe(data => {
    //   this.position = data;
    //   this.initilizeMap();
    // });
  }

  initilizeMap() {
    const lonLat = [Number(this.positions[0].latitude), Number(this.positions[0].longitude)];
    this.map = new Map({
      layers: [
        new TileLayer({
          source: new OSM(),
        })
      ],
      target: 'map',
      view: new View({
        center: fromLonLat(lonLat),
        zoom: 16
      })
    });
    this.setRoute();
  }
  setRoute() {

    // var lonlat = fromLonLat([20.5022416, 44.7803966]);
    // var location2 = fromLonLat([20.5022183, 44.7808116]);

    var lonlats = [];

    for (let pos of this.positions) {
      debugger;
      var lonlat = fromLonLat([Number(pos.latitude), Number(pos.longitude)]);
      lonlats.push(lonlat);
    }

    var linie2style = [
      new Style({
        stroke: new Stroke({
          color: '#00008B',
          width: 4
        })
      })
    ];

    var linie2 = new VectorLayer({
      source: new VectorSource({
        features: [new Feature({
          geometry: new LineString(lonlats),
          name: 'Line',
        })]
      })
    });

    linie2.setStyle(linie2style);
    this.map.addLayer(linie2);
  }
}
